/**
 * Confirm 弹框组件
 */
 
<template>
  <div class="confirm">
        <div class="confirm__alert">
          <div class="confirm__content">{{content}}</div>
          <div class="confirm__btns">
            <a class="confirm__btn confirm__btn--cancel" @click="cancelEvent">
              {{cancelText}}
            </a>
            <a class="confirm__btn" @click="submitEvent">
              {{submitText}}
            </a>
          </div>
        </div>
      </div>
</template>

<script>

export default {
  name: "Confirm",
  props:{
        content: {
            type: String,
            required:true
        },
        cancelText:{
            type: String,
            default: "取消"
        },
        submitText:{
            type: String,
            default: "确定"
        },
        cancelEvent:Function,
        submitEvent:Function
    },
  data() {
    return {};
  },
  components: {},
  methods: {
  },
  create() {},
  mounted() {}
};
</script>

<style lang="less" scoped>
.confirm {
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background: rgba(0, 0, 0, 0.6);
    z-index: 300;
    position: fixed;
  }
  
  .confirm__alert {
    width: 280px;
    background: #fff;
    border-radius: 10px;
    left: 50%;
    top: 50%;
    border: 1px solid #efefef;
    margin: -50px 0 0 -140px;
    z-index: 10000002;
    position: fixed;
    text-align: center;
  }
  
  .confirm__content {
    padding: 20px;
    border-bottom: solid 1px #efefef;
  }
  
  .confirm__btns {
    font-size: 14px;
    height: 40px;
    line-height: 40px;
  }
  
  .confirm__btn {
    color: #08c;
    float: left;
    width: 50%;
    height: 100%;
    box-sizing: border-box;
    cursor: pointer;
  }
   .confirm__btn--cancel{
    border-right: solid 1px #efefef;
    width: calc(50% - 1px);
  }
</style>
